import { Flex, Grid, GridItem, Text } from '@chakra-ui/react'

import { CopyButton } from '../../../components/ActionButton'
import { bankLabel } from '../../../components/BankSelect'
import { DetailField } from '../../../components/DetailField'
import { FormModal } from '../../../components/FormModal'
import { formatPhone } from '../../../helpers'
import { IEventCommissionSummaryItem } from '../../../services/EventCommissions/interfaces'
import { pixKeyTypeLabels } from '../EventCoupons/couponLabels'
import { sellerDisplayName } from './commissionDisplay'

interface IProps {
  isOpen: boolean
  onClose: () => void
  seller: IEventCommissionSummaryItem
}

/**
 * Dados de pagamento do parceiro, só leitura.
 *
 * Parceiro não tem cadastro: os dados são digitados no cupom, e esta é a tela onde a
 * comissão dele é apurada — então é aqui que quem paga precisa lê-los. Editar continua
 * sendo no cupom.
 */
export default function PartnerContactModal({ isOpen, onClose, seller }: IProps) {
  const contact = seller.partner_contact
  // Quem vai pagar precisa saber o que está copiando: onze dígitos podem ser CPF ou telefone.
  const pixKeyLabel = contact?.partner_pix_key_type
    ? `Chave Pix (${pixKeyTypeLabels[contact.partner_pix_key_type]})`
    : 'Chave Pix'

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title={
        <>
          {sellerDisplayName(seller)}
          <Text variant="caption">Dados para pagamento da comissão</Text>
        </>
      }
    >
      <Grid templateColumns="repeat(2, 1fr)" gap={4}>
        <DetailField
          label="Banco"
          value={bankLabel(contact?.partner_bank_code ?? null, contact?.partner_bank_name ?? null) || null}
          gridColumn="span 2"
        />
        <DetailField label="Agência" value={contact?.partner_bank_agency ?? null} />
        <DetailField label="Conta corrente" value={contact?.partner_bank_account ?? null} />
        <DetailField label="Nome do titular" value={contact?.partner_bank_holder_name ?? null} gridColumn="span 2" />
        <GridItem colSpan={2}>
          <Flex align="flex-end" gap={2}>
            <DetailField label={pixKeyLabel} value={contact?.partner_pix_key ?? null} flex={1} />
            {contact?.partner_pix_key && <CopyButton value={contact.partner_pix_key} entity="chave Pix" feminine />}
          </Flex>
        </GridItem>
        <DetailField label="Telefone de contato" value={formatPhone(contact?.partner_phone)} gridColumn="span 2" />
      </Grid>
      <Text variant="caption" mt={4}>
        Cadastrados no cupom do parceiro — para alterar, edite o cupom em Cupons de Desconto.
      </Text>
    </FormModal>
  )
}
